import React, { useRef, useCallback, useMemo } from "react";
import { Grid } from "@mui/material";
import SortFilter from "../../SortFilter/SortFilter";
import moment from "moment";
import { DateFormats } from "../../constants/securspace-constants";
import { sortByOptions } from "../data";
import { getAllLocationsByBuyer } from "../../location/requests/location-requests";
import useGetRequestBody from "../../../hooks/useGetRequestBody";
import {withSnackbar} from "../../hocs/withSnackbar";

const BuyerInterChangesFilters = React.memo(({
  setStartDate,
  setEndDate,
  setSortBy,
  setSelectedLocation,
  setEquipmentNumber,
  setEquipmentType,
  setSupplierName,
  snackbarShowMessage,
  setDriverName,
  setDriverNameExact,
  setSortDir,
  supplierName,
  equipmentNumber,
  driverName,
  driverNameExact,
  filterSelectOptions
}) => {

  const buyerLocations = useGetRequestBody(getAllLocationsByBuyer, useMemo(() => [], []), snackbarShowMessage);

  const locations = useMemo(() => {
    return [{id: "", locationName: "All"}, ...buyerLocations];
  },[buyerLocations]);

  const initialRender = useRef(true);

  const handleCallback = useCallback((e) => {
    const parseFilters = (filterArray) => {
      const supplierName = filterArray.find(item => item.name === "supplierName")?.value;
      const equipmentNumber = filterArray.find(item => item.name === "equipmentNumber")?.value;
      const driverName = filterArray.find(item => item.name === "driverName")?.value;
      const driverNameExact = filterArray.find(item => item.name === "driverNameExact")?.value;

      return {
        supplierName,
        equipmentNumber,
        driverName,
        driverNameExact,
      }
    };

    if (!initialRender.current) {
      setStartDate(e.startDate);
      setEndDate(e.endDate);
      setSortBy(e.sortBy);
      const filters = parseFilters(e.filters);
      setEquipmentNumber(filters.equipmentNumber);
      setEquipmentType(e.selectFilters?.find(item => item.name === "equipmentType")?.value);
      setSupplierName(filters.supplierName);
      setSelectedLocation(e.location);
      setDriverName(filters.driverName);
      setDriverNameExact(filters.driverNameExact);
      setSortDir(e.sortDir)
    } else {
      initialRender.current = false;
    }
  }, [setDriverName, setEndDate, setEquipmentNumber, setEquipmentType, setSelectedLocation, setSortBy, setSortDir, setStartDate, setSupplierName]);

  const lastMonthDate = moment().add(-1, 'months').format(DateFormats.DAY).toString();
  const todayDate = moment().format(DateFormats.DAY).toString();

  const filterByOptions = useMemo(() => {
    return [
      { label: "Supplier Name", name: "supplierName", value: supplierName },
      { label: "Equipment Number", name: "equipmentNumber", value: equipmentNumber },
      { label: "Driver Name", name: "driverName", value: driverName },
      { type: "checkbox", label: "Exact Name Match", name: "driverNameExact", value: driverNameExact }
    ];
  }, [supplierName, equipmentNumber, driverName, driverNameExact]);


  return (
    <Grid item mb={4}>
      <SortFilter
        filterCallback={handleCallback}
        locations={locations}
        filterByOption={filterByOptions}
        defaultStartDate={lastMonthDate}
        defaultEndDate={todayDate}
        sortByOption={sortByOptions}
        filterBySelectOption={filterSelectOptions}
        defaultSortBy={sortByOptions[1].value}
        sortDir={"desc"}
       locationOption={[]}
      />
    </Grid>
  )
});

BuyerInterChangesFilters.displayName = "BuyerInterChangesFilters";

export default withSnackbar(BuyerInterChangesFilters);
